'use client'

import { useEffect } from 'react'

import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons'

import type { TermsMetadataResponseInner } from '@b-stock/account-api-client'
import {
  EmptyState,
  FormattedMessage,
  ddLogger,
} from '@b-stock/fe-core/bstock-react'

type Props = {
  listingId: string
  termsMetadata: TermsMetadataResponseInner | null
}

export const TermsLoadError = ({ listingId, termsMetadata }: Props) => {
  /* eslint-disable react-hooks/exhaustive-deps, react-compiler/react-compiler */
  useEffect(() => {
    ddLogger.error('ListingDetailsPage: terms doc URL missing', {
      listingId,
      missingField: 'termsMetadata.docUrl',
      termsMetadata,
    })
  }, [])
  /* eslint-enable react-hooks/exhaustive-deps, react-compiler/react-compiler */

  return (
    <div data-testid="TermsLoadError">
      <EmptyState
        icon={faExclamationTriangle}
        title={
          <FormattedMessage id="Common.termsRestrictions.loadError.title" />
        }
        description={
          <FormattedMessage id="Common.termsRestrictions.loadError.description" />
        }
      />
    </div>
  )
}
